import { PromptBenefits, PromptSheet } from '../components/PromptSheet';
import { Bell, BellOff, CalendarCheck, Clock } from 'lucide-react';

type PushActivationPromptProps = {
    permission: NotificationPermission | null;
    loading: boolean;
    onActivate: () => void;
    onClose: () => void;
};

export function PushActivationPrompt({ permission, loading, onActivate, onClose }: PushActivationPromptProps) {
    if (permission === 'denied') {
        return (
            <PromptSheet
                icon={BellOff}
                tone="warning"
                title="Notificações bloqueadas"
                description="As notificações foram bloqueadas neste navegador. Para receber avisos aqui, é preciso liberar nas configurações dele."
                onClose={onClose}
            >
                <ol className="list-decimal space-y-2 rounded-2xl bg-base-200 py-3.5 pl-9 pr-4 text-sm text-base-content/80 dark:bg-base-300">
                    <li>Abra as configurações deste site no navegador, pelo ícone ao lado do endereço ou pelo menu.</li>
                    <li>Em Notificações, escolha Permitir.</li>
                    <li>Volte e atualize a página.</li>
                </ol>
                <button type="button" className="btn btn-primary mt-5 h-12 w-full rounded-full" onClick={onClose}>Entendi</button>
            </PromptSheet>
        );
    }

    return (
        <PromptSheet
            icon={Bell}
            title="Ativar notificações"
            description="Receba os avisos neste aparelho, mesmo com o app fechado."
            onClose={onClose}
        >
            <PromptBenefits
                items={[
                    { icon: CalendarCheck, text: 'Agendamentos e confirmações' },
                    { icon: Clock, text: 'Mudanças e cancelamentos de horário' },
                ]}
            />
            <button type="button" className="btn btn-primary mt-5 h-12 w-full rounded-full" onClick={onActivate} disabled={loading}>
                {loading ? <span className="loading loading-spinner loading-sm" aria-label="Ativando"></span> : 'Ativar notificações'}
            </button>
            <button type="button" className="btn btn-ghost mt-1 h-11 min-h-11 w-full rounded-full text-base-content/65" onClick={onClose} disabled={loading}>
                Agora não
            </button>
        </PromptSheet>
    );
}
